const API_BASE = String(
  process.env.REACT_APP_NODE_API_URL || process.env.REACT_APP_API_URL || ""
).replace(/\/$/, "");

const UPLOAD_PATH = /^\/uploads\//;
const IMAGE_PATH = /^\/image\//;

function isExternalUrl(value) {
  return /^https?:\/\//i.test(value);
}

function isBlobOrDataUrl(value) {
  return /^(data:|blob:)/i.test(value);
}

/** Strip host from legacy absolute upload URLs; keep external URLs unchanged. */
export function toRelativeMediaPath(path) {
  if (path == null || typeof path !== "string") {
    return path;
  }
  const trimmed = path.trim();
  if (!trimmed || isBlobOrDataUrl(trimmed)) {
    return trimmed;
  }
  if (isExternalUrl(trimmed)) {
    try {
      const { pathname, search } = new URL(trimmed);
      if (UPLOAD_PATH.test(pathname) || IMAGE_PATH.test(pathname)) {
        return `${pathname}${search}`;
      }
    } catch {
      // ignore
    }
    return trimmed;
  }
  return trimmed;
}

/** Resolve a DB-stored path to a full URL for display (img src, CSS url()). */
export function resolveMediaUrl(path) {
  if (path == null || typeof path !== "string") {
    return path;
  }
  const trimmed = path.trim();
  if (!trimmed || isBlobOrDataUrl(trimmed)) {
    return trimmed;
  }
  if (trimmed.startsWith("/static/")) {
    return trimmed;
  }

  const relative = toRelativeMediaPath(trimmed);

  if (isExternalUrl(relative)) {
    return relative;
  }

  if (UPLOAD_PATH.test(relative) || IMAGE_PATH.test(relative)) {
    return API_BASE ? `${API_BASE}${relative}` : relative;
  }

  if (!relative.includes("/") && !relative.includes("\\")) {
    return API_BASE ? `${API_BASE}/image/${relative}` : `/image/${relative}`;
  }

  return relative;
}

export function resolveMediaCssUrl(path) {
  const resolved = resolveMediaUrl(path);
  if (!resolved) {
    return "";
  }
  return `url("${resolved}")`;
}
